import React from 'react';
import {EmptyContainer} from '../styles';
import Img4 from '../../../assets/images/4.png';
import {config} from '../../../utils/config/config';
import {HealthBoxInfo, HealthExportContainer, HealthTableContainer} from './styles';
import {BoxInfo, EmptyCard, EmptyImage, FluidContainer, HealthTable, LargeButton} from '../../../components';

export default () =>
  config.blocked ? (
    <EmptyContainer>
      <EmptyCard />
      <EmptyImage src={Img4} />
    </EmptyContainer>
  ) : (
    <FluidContainer>
      <HealthBoxInfo data-cy="info-container">
        <BoxInfo
          symbol="%"
          result={4.1}
          unit="lbs."
          previous={'4.3'}
          extraInfo={4.3}
          changeValue={4.6}
          title="ARM FEELS"
          boxTitle="CURRENT"
          headerLeft="7 Day Avg: "
        />
        <BoxInfo
          unit="º"
          result={88.2}
          symbol="º"
          ruler="lbs."
          previous={'88'}
          extraInfo={75.4}
          boxTitle="YESTERDAY"
          changeValue={12.8}
          headerLeft="7 Day Avg: "
          title="ARM CARE ACCOUNTABILLITY"
        />
      </HealthBoxInfo>
      <HealthExportContainer data-cy="export-container">
        <LargeButton
          title="d"
          lColor="var(--PrimaryGreen)"
          rColor="var(--SecondaryGreen)"
          lMargin="0px 7px"
          rMargin="0px 10px"
          icon="excel"
          rIcon="download"
          callback={() => {}}
        />
      </HealthExportContainer>
      <HealthTableContainer data-cy="table-container">
        <HealthTable />
      </HealthTableContainer>
    </FluidContainer>
  );
